// @ts-nocheck
/* eslint-disable */
import { CONFIG } from "~/config";
import MyMapsPopup from "~/es6/mymaps.popup";
import { _ } from "~/i18n";
import { icon, node } from "~/util/dom";

(function() {
	const ROUTE = 0;
	const DISTANCEMETER = 1;
	const CIRCUIT = 2;
	const USERMARKS = 3;
	const TRACK = 4;
	const FOLDER = 5;
	const ROUTE_BACKPACK = 6;
	const PATH = 7;

	const ENDPOINTS = [
		"/tplannerexport",
		"/export",
		"/tplannerexport",
		"/export",
		"/mapybox-export",
		"/mapybox-export",
		"/tplannerexport",
		"/mapybox-export"
	];

	const FORMATS = [
		{ name: "GPX", type:"gpx" },
	];

	class DownloadPopup {
		constructor(opts = {}) {
			this._popup = new MyMapsPopup({
				name: "downloadpopup"
			});
			let dummy = () => {};
			this._buttons = FORMATS.map(format => node("button", { type: "button", innerHTML: format.name }));
			this._loader = node("img", { src: "/img/loader.gif", className: "spinner hidden" });
			this._data = opts.data || null;
			this._type = opts.type || ROUTE;
			this._optionElements = opts.optionElements || null;
			this._optionsObject = {};
			this._msg = opts.msg;
			this._filename = opts.filename || "export";
			this._onSuccess = opts.onSuccess || dummy;
			this._onError = opts.onError || dummy;
			this._onStartDownload = opts.onStartDownload || dummy;
			this._fileTypeFromHeader = opts.fileTypeFromHeader || false;
			this._endCb = null;
			this._create();
		}

		handleEvent(e) {
			switch (e.type) {
				case "click":
					this._buttons.some((button, index) => {
						const done = button == e.target;

						if (done) {
							this._popup.getContainer().removeEventListener("click", this, false);
							button.parentNode.classList.add("inactive");
							if (this._endCb) {
								this._endCb();
								this._endCb = null;
							}
							this._download(FORMATS[index].type);
						}

						return done;
					});
					break;
			}
		}

		open() {
			this._popup.open();
			this._popup.getContainer().addEventListener("click", this, false);
		}

		/**
		 * Vytvoří v popupu čekací text s loaderem
		 * @param {String} [header = null] Nadpis
		 * @param {String} [message = null] Zpráva
		 * @param {Number} [time = 2000] Po jaké době v ms se objeví zpráva (pokud je)
		 */
		setWaitWindow(header = null, message = null, time = 2000) {
			let cont = this._popup.getContainer();
			Mapy.Util.clear(cont);
			cont.appendChild(this._popup.closeButton);
			let div = node("div", { className: "waitmessage"});
			div.appendChild(this._loader);
			if (header) {
				div.appendChild(node("h2", { className: "header", textContent:  header}));
			}
			if (message) {
				let p = node("p", { textContent:  message});
				setTimeout(() => {
					p.classList.add("visible");
				}, time);
				div.appendChild(p);
			}
			cont.appendChild(div);
		}


		set endCb(value) {
			this._endCb = value;
		}

		_close() {
			this._popup.getContainer().removeEventListener("click", this, false);
			if (this._popup.isOpen) {
				this._popup.close();
			}
		}

		_create() {
			let buttons = node("div", { className: "buttons" });
			this._buttons.forEach(button => buttons.appendChild(button));
			buttons.appendChild(this._loader);

			let cont = this._popup.getContainer();
			cont.appendChild(node("h2", { className: "header", textContent: _("action.download.title") }));
			if (this._msg) { cont.appendChild(node("p", { textContent: this._msg })); }
			if (this._optionElements) { cont.appendChild(this._createOptionsBox()); };
			cont.appendChild(buttons);
		}

		_download(format) {
			this._onStartDownload();
			this._loader.classList.remove("hidden");

			let appendix = "";
			let data = {"export": [format.toLowerCase()]};

			if (this._type == ROUTE) {
				let allParams = [`export=${format.toLowerCase()}`];

				Object.keys(this._data).forEach(name => {
					let values = this._data[name];

					if (values) {
						values.forEach(value => {
							allParams.push(`${name}=${value}`);
						});
					}
				});

				if (this._optionsObject.tponly) {
					allParams.push(`tponly=${this._optionsObject.tponly.label.querySelector("input").checked ? 0 : 1}`);
				}

				appendix = allParams.length > 0 ? "?" + allParams.join("&") : "";
			} else if (this._type == FOLDER && this._data) {
				appendix = `/v1/folder/${format}?id=${this._data}&export=${data.export}&${this._getValues()}`;
			} else if (this._type == PATH && this._data) {
				appendix = `/v1/path/${format}?id=${this._data}`;
			} else if (this._type == ROUTE_BACKPACK && this._data) {
				data.data = [JSON.stringify(this._data)];

				if (this._optionsObject.tponly) {
					data.tponly = [this._optionsObject.tponly.label.querySelector("input").checked ? 0 : 1];
				}
			} else {
				for (let p in this._data) {
					if ((typeof this._data[p]).toLowerCase() != "string" && (typeof this._data[p]).toLowerCase() != "number") {
						for (let i = 0; i < this._data[p].length; i++) {
							p in data ? data[p].push(this._data[p][i]) : data[p] = [this._data[p][i]];
						}
					} else {
						p in data ? data[p].push(this._data[p]) : data[p] = [this._data[p]];
					}
				}
				if (this._type == TRACK) {
					appendix = `/v1/track/${format}?tid=${this._data.mid}`;
				}
			}

			let onFinish = f => {
				return err => {
					this._loader.classList.add("hidden");
					this._close();
					//logování začátek
					let opts = {
						format,
						type: this._typeName
					};
					let values = this._getValues();
					if (values) {
						let pairs = values.split("&");
						let pairObj = {};
						pairs.forEach(pair => {
							let keyVal = pair.split("=");
							if (keyVal.length == 2) {
								pairObj[keyVal[0]] = keyVal[1];
							}
						});
						Object.assign(opts, pairObj);
					}
					Mapy.getComponent("logger").log("export_gpx_kml", opts);
					//logování konec
					f(err);
				};
			};

			Mapy.Util.startDownload({
				url: `${ENDPOINTS[this._type] === "/export" ? `${window.location.origin}` : `${CONFIG.requestUrl}`}${ENDPOINTS[this._type]}${appendix != "" ? `${appendix}&` : `?`}rand=${Math.random().toString()}`,
				data: this._isExcluded ? {} : data,
				onSuccess: onFinish(this._onSuccess),
				onError: onFinish(this._onError),
				filename: this._filename + "." + format,
				method: this._isExcluded ? "GET" : "POST",
				fileTypeFromHeader: this._fileTypeFromHeader
			});
		}

		/**
		 * Vytvoří blok s přepínači
		 * @return {HTMLDivElement}
		 */
		_createOptionsBox() {
			let container = node("div", {className: "options-box"});
			let opener;

			if (this._optionElements.label) {
				opener = node("div", {
					textContent: this._optionElements.label,
					className: "opener"
				});
				opener.appendChild(icon("dropdown"));
				container.appendChild(opener);
			}

			let switches = node("div", {className: "switches"});
			this._optionsObject = {};
			let oldOptions = {};
			try {
				oldOptions = JSON.parse(localStorage.getItem("gpxexportoptions")) || {};
			} catch (ex) {
				//
			}

			this._optionElements.items.forEach(item => {
				let label = node("label", {className: "switch"});
				let input = node("input", {type: item.type});
				if("enabled" in item || item.name in oldOptions) {
					switch (item.type) {
						case "checkbox":
						case "radio":
							input.checked = item.name in oldOptions ? oldOptions[item.name ] : item.enabled;
							break;
					}
				}
				label.appendChild(input);
				label.appendChild(node("span", {className: "slider"}));
				label.appendChild(Mapy.Util.text(item.title));
				switches.appendChild(label);
				this._optionsObject[item.name] = {
					label,
					reverse: !!item.reverse
				};
			});

			container.appendChild(switches);

			//spočítáme max. výšky pro animaci
			let div = node("div", {className: "downloadpopup"});
			div.style.position = "absolute";
			div.style.top = "100px";
			div.style.left = "100px";
			div.style.zIndex = "99";
			div.style.width = "400px";
			div.appendChild(container);
			container.classList.add("opened");
			document.body.appendChild(div);
			let coBBox = container.getBoundingClientRect();
			let swBBox = switches.getBoundingClientRect();

			container.remove();
			div.remove();

			if (this._optionElements.label) {
				container.classList.remove("opened");

				opener.addEventListener("click", () => {
					container.classList[container.classList.contains("opened") ? "remove" : "add"]("opened");
					container.setAttribute("style", `max-height: ${container.classList.contains("opened") ? coBBox.height : 24}px`);
					switches.setAttribute("style", `max-height: ${container.classList.contains("opened") ? swBBox.height : 0}px`);
				});

				container.setAttribute("style", `max-height: 24px`);
				switches.setAttribute("style", `max-height: 0px`);
			}

			return container;
		}

		/**
		 * Z bloku s přepínači získá hodnoty jako querystring
		 * @return {String}
		 */
		_getValues() {
			let keys = Object.keys(this._optionsObject);
			if (keys.length) {
				let state = {};
				let keyVal = [];
				keys.forEach(key => {
					let input = this._optionsObject[key].label.querySelector("input");
					let reverse = this._optionsObject[key].reverse;
					if (input) {
						let value = "";
						switch (input.type) {
							case "checkbox":
							case "radio":
								value = reverse ? !input.checked : input.checked;
								break;
						}
						state[key] = input.checked;
						keyVal.push(`${key}=${value}`);
					}
				});
				let oldOptions = null;
				try {
					oldOptions = JSON.parse(localStorage.getItem("gpxexportoptions"));
				} catch(ex) {
					//
				};
				try {
					localStorage.setItem("gpxexportoptions", JSON.stringify(oldOptions ? Object.assign({}, oldOptions, state) : state));
				} catch (ex) {
					//
				}

				return keyVal.join("&");
			}
			return "";
		}

		/**
		 * Jde o speciální typ?
		 * @return {Boolean}
		 */
		get _isExcluded() {
			return (this._type == FOLDER || this._type == ROUTE);
		}

		/**
		 * Jméno aktuálního typu
		 * @return {string|null}
		 */
		get _typeName() {
			if (this._type == Mapy.DownloadPopup.ROUTE_BACKPACK) {
				return "route";
			}

			for (let key in Mapy.DownloadPopup) {
				if(Mapy.DownloadPopup[key] == this._type) {
					return key.toLowerCase();
				}
			}
			return null;
		}
	}

	Mapy.DownloadPopup = DownloadPopup;
	Mapy.DownloadPopup.ROUTE = ROUTE;
	Mapy.DownloadPopup.DISTANCEMETER = DISTANCEMETER;
	Mapy.DownloadPopup.CIRCUIT = CIRCUIT;
	Mapy.DownloadPopup.USERMARKS = USERMARKS;
	Mapy.DownloadPopup.TRACK = TRACK;
	Mapy.DownloadPopup.FOLDER = FOLDER;
	Mapy.DownloadPopup.ROUTE_BACKPACK = ROUTE_BACKPACK;
	Mapy.DownloadPopup.PATH = PATH;
}());
